module.exports = __webpack_public_path__ + "static/media/student9.89b8e4bc.png";